"use client";

import Image from "next/image";
import Link from "next/link";

export default function ConsultationSection() {
  return (
    <section className="bg-[#2a6380] mb-0 lg:mb-8 pt-16 pb-16 sm:pb-16 lg:pb-0 px-6 sm:px-8 lg:px-20 relative overflow-visible">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-[40%_60%] items-center ">
        {/* Image Section */}
        <div className="relative flex justify-center lg:justify-start">
          <div
            className="
              relative w-[90%] sm:w-[80%] md:w-[95%]
              h-60 sm:h-80 md:h-[400px] lg:h-[480px]
              rounded-xl overflow-hidden shadow-xl
              mb-0 sm:mb-0 lg:mb-[-80px]
              transition-all duration-500
            "
          >
            <Image
              src="/consultation.jpg"
              alt="Consultation"
              fill
              className="object-cover"
              priority
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 40vw, 500px"
            />
          </div>
        </div>

        {/* Text Section */}
        <div className="text-center lg:text-left text-white px-2 sm:px-0">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#33c1c7] mb-4">
            Consultation
          </h2>

          <p className="text-sm sm:text-base lg:text-lg text-justify mb-3 leading-relaxed">
            We begin with a comprehensive consultation to understand your needs,
            goals, and vision for your project.
          </p>

          <p className="text-sm sm:text-base lg:text-lg mb-6 text-justify leading-relaxed">
            Our experts develop a detailed plan and strategy tailored to your
            specific requirements and budget.
          </p>

          <Link
            href="/team"
            className="relative overflow-hidden inline-block border-2 border-[#33c1c7] bg-[#33c1c7] text-[#0B2149] font-semibold px-6 py-3 rounded transition-all duration-500 ease-in-out group"
          >
            <span className="relative z-10 transition-colors duration-500 group-hover:text-[#33c1c7]">
              Meet Our Team
            </span>
            <span className="absolute inset-0 bg-[#0B2149] scale-[-1] -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-in-out"></span>
          </Link>
        </div>
      </div>
    </section>
  );
}
